<template>
  <v-app>
    <v-overlay :value="$store.getters.overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <app-bar
      :header-menu="headerMenu"
      :profile-menu="profileMenu"
      dense
      dark
      :style="background"
      @toggle="
      $vuetify.breakpoint.lgAndUp ? (mini = !mini) : (drawer = !drawer)
      "></app-bar>

      <sidebar
      :menu="sidebarMenu"
      v-model="drawer"
      :mini-variant="mini">
  </sidebar>
  <v-main>
    <div class="d-flex flex-column fill-height">
      <v-container fluid class="flex">
        <transition name="fade" mode="out-in">
          <component :is="'error'" v-if="$store.state.messages.error" :error="$store.state.messages.error"></component>
          <router-view v-else />
        </transition>
      </v-container>
      <footed :menu="footerMenu">
        &copy; 2021,
        <v-icon size="18"> mdi-xml </v-icon>
        with
        <v-icon size="18"> mdi-heart </v-icon>
        by
        ICT for a better web.
      </footed>
    </div>
  </v-main>
  <asided></asided>
</v-app>
</template>

<script>
  import nav from "../_nav";
  import AppBar from "./AppBar";
  import Sidebar from "./Sidebar";
  import Asided from "./Aside";
  import Footed from "./Footer";
  export default {
    components: {
      AppBar,
      Sidebar,
      Asided,
      Footed
    },
    name: "App",
    data() {
      return {
        drawer: null,
        mini: false,
        headerMenu: [],
        footerMenu: [],
        profileMenu: [],
        sidebarMenu: nav(this.$i18n, this.$admin,this.$store),
      };
    },
    computed: {
    background: function() {
       if(this.$store.getters.authen.locale=='th'){
        return 'background-color: #cb3525 !important';
       }else{
        return 'background-color: #2b3b90 !important';
       }
      }
    },
  };
</script>
<style type="text/css">
.top-bg{
  background-color: #cb3525 !important;
}
</style>
